import { render } from "./SettingsSidePanel.vue?vue&type=template&id=643955ae"
import script from "./SettingsSidePanel.vue?vue&type=script&lang=js"
export * from "./SettingsSidePanel.vue?vue&type=script&lang=js"
script.render = render

export default script